import {DEVICE_MODE, DEVICE_MODE_GET, DEVICE_INNER_SIZE} from "../actions/DeviceModeAction";

const initialState = {
    mode: "desktop",
    width: "1200",
    height: "700"
};

const DeviceModeReducer = (state = initialState, action) => {
    switch (action.type) {
        case DEVICE_MODE:
            return { mode: action.payload };
        case DEVICE_MODE_GET:
            return state.mode ;
        case DEVICE_INNER_SIZE:
            if(action.payload.width <= 600 ){
                return { mode: "mobile", width: action.payload.width, height: action.payload.height };
            } else if(action.payload.width <= 1000 ){
                return { mode: "tablet", width: action.payload.width, height: action.payload.height };
            } else {
                return { mode: "desktop", width: action.payload.width, height: action.payload.height };
            }
        default:
            return state;
    }
}

export default DeviceModeReducer;
